import { render, staticRenderFns } from "./CreateModel.vue?vue&type=template&id=61a344e8&scoped=true&"
import script from "./CreateModel.vue?vue&type=script&lang=js&"
export * from "./CreateModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a344e8",
  null
  
)

export default component.exports